import { Star, Shield, FileCheck, Award, Building2, Phone, Mail, Clock, MapPin, Scale, Users, CheckCircle2, ArrowRight, BadgeCheck, Lock, Globe, CreditCard, FileText, Landmark, ChevronRight } from "lucide-react";

export const NAV_LINKS = [
  { id: "home", href: "#inicio" },
  { id: "process", href: "#proceso" },
  { id: "guarantee", href: "#garantia" },
  { id: "offices", href: "#sedes" },
  { id: "faq", href: "#faq" },
];

export const TRUST_METRICS = [
  { value: "+190", label: "Expedientes Validados", icon: FileCheck },
  { value: "4.6/5", label: "Valoración en Google", icon: Star },
  { value: "100%", label: "Abogados Colegiados", icon: BadgeCheck },
  { value: "Garantía", label: "Reembolso Directo", icon: Shield },
];

export const PRICING_FEATURES = [
  "Auditoría documental completa",
  "Informe de Viabilidad jurídico",
  "Firma de Abogado colegiado",
  "Presentación Telemática oficial",
  "Seguimiento del expediente",
  "Resguardo oficial de presentación",
];

export const METHODOLOGY_PHASES = [
  {
    phase: "01",
    title: "Auditoría Técnica",
    description: "Recepción de documentos y análisis exhaustivo de requisitos previos. Verificamos su Pasaporte, Padrón y demás documentación esencial.",
    icon: FileText,
    detail: "Revisión completa en 48h",
  },
  {
    phase: "02",
    title: "Certificación de Viabilidad",
    description: "Emisión del dictamen jurídico positivo y firma del contrato de servicios con garantía de éxito incluida.",
    icon: BadgeCheck,
    detail: "Dictamen en 72h",
  },
  {
    phase: "03",
    title: "Ejecución y Amparo",
    description: "Presentación oficial ante la Oficina de Extranjería y entrega del Resguardo oficial de presentación como justificante de trámite.",
    icon: Landmark,
    detail: "Presentación inmediata",
  },
];

export const FAQ_DATA = [
  {
    question: "¿Puedo empezar si me falta algún documento?",
    answer: "Sí, por supuesto. Nuestro equipo le asesorará en la obtención de cualquier documento pendiente. Muchos de nuestros clientes inician el proceso mientras completan su documentación, y les guiamos paso a paso en cada trámite necesario.",
  },
  {
    question: "¿Qué ocurre si mi caso no es viable?",
    answer: "Se le informa honestamente y no se inicia el cobro de honorarios. Nuestra política de transparencia nos obliga a comunicarle con total claridad si su situación no cumple los requisitos legales, sin compromiso económico alguno por su parte.",
  },
  {
    question: "¿Cómo realizo los pagos de las cuotas?",
    answer: "Puede realizar los pagos vía transferencia bancaria, tarjeta de crédito/débito o en efectivo en nuestra sede central de Santa Cruz de Tenerife. Las cuotas son quincenales y sin intereses.",
  },
  {
    question: "¿Es seguro enviar mis documentos online?",
    answer: "Absolutamente. Cumplimos estrictamente con la LOPD (Ley Orgánica de Protección de Datos) y utilizamos protocolos de encriptación avanzados para garantizar la máxima seguridad en la transmisión y almacenamiento de su información personal.",
  },
];

export const FOOTER_DATA = {
  about: "ResidenciaYA.es es un despacho especializado en Derecho de Extranjería con sede central en Santa Cruz de Tenerife. Nuestro compromiso es democratizar el acceso a la mejor defensa legal, ofreciendo transparencia, rigor y resultados.",
  legal: [
    { label: "Aviso Legal", href: "/aviso-legal" },
    { label: "Política de Privacidad (LOPD)", href: "/politica-privacidad" },
    { label: "Política de Cookies", href: "/politica-cookies" },
    { label: "Condiciones de Contratación", href: "/condiciones" },
    { label: "Red de Aliados", href: "/aliados" },
  ],
  social: {
    facebook: "https://facebook.com/residenciaya.es",
    instagram: "https://www.instagram.com/residenciaya.es/"
  },
  contact: {
    address: "Calle Pepita Serrador, Nº 2, Local 3, 38005 Santa Cruz de Tenerife",
    phone: "+34 624 511 532",
    email: "info@residenciaya.es",
  },
  hours: [
    { day: "Lunes a Viernes", time: "09:00 - 18:00" },
    { day: "Sábados", time: "Cerrado" },
    { day: "Domingos", time: "Cerrado" },
  ],
};

export const HERO_IMAGE = "https://images.unsplash.com/photo-1571624436279-b272aff752b5?auto=format&fit=crop&w=1920&q=80";
export const DOCS_IMAGE = "https://images.unsplash.com/photo-1619418602850-35ad20aa1700?auto=format&fit=crop&w=800&q=80";
export const LAWYER_IMAGE = "https://images.unsplash.com/photo-1658249682487-882436e01650?auto=format&fit=crop&w=800&q=80";
